import React from 'react'
import Comming_soon from './commimg-soon/Comming_soon'

function Welcome() {
  return (
    <>
     <Comming_soon />
    </>
  )
}

export default Welcome